// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};


//////////////////
// WEBPACK FOOTER
// ./src/style/index.styl
// module id = 242
// module chunks = 0